import { Component, OnInit } from '@angular/core';
import { Persona } from '@app/persona/models';
import { Observable, Subject } from 'rxjs';
import { NzPopoverDirective } from 'ng-zorro-antd/popover';
import { NzSelectComponent } from 'ng-zorro-antd/select';
import { PersonaUI, personaUIComparator, toPersonaUI } from '@app/persona/containers/persona-list/persona-map';
import { PersonaPickerService } from '@app/persona/services/persona-picker.service';
import { map, tap, withLatestFrom } from 'rxjs/operators';
import { PersonaUITypes } from '@app/persona/constants/constants';

@Component({
    selector: 'app-persona-picker-popover',
    templateUrl: './persona-picker-popover.component.html',
    styleUrls: ['./persona-picker-popover.component.scss']
})
export class PersonaPickerPopoverComponent implements OnInit {

    selectedPersonaUI$: Observable<PersonaUI>;
    hasToSelectPersona$: Observable<boolean>;
    confirm$ = new Subject<void>();

    comparator() {
        return personaUIComparator;
    }

    getConfirm$(toSelectPersona$: Observable<Persona>) {
        return this.confirm$.pipe(
            withLatestFrom(toSelectPersona$),
            tap(([_, personaToSet]) => {
                this.personaPicker.setPersona(personaToSet);
            })
        );
    }

    onConfirm(popover: NzPopoverDirective) {
        this.confirm$.next();
        popover.hide();
    }

    onCancel(popover: NzPopoverDirective) {
        popover.hide();
    }

    onSelect(id: string, popover: NzPopoverDirective) {
        this.personaPicker.setToSelectPersona(id);
        setTimeout(() => this.onConfirm(popover));
    }

    changeSelectOpen(visibility: boolean, selectComponent: NzSelectComponent) {
        if (!visibility) {
            selectComponent.nzOpen = false;
        }
    }

    private getSelectedPersonaUI$() {
        return this.personaPicker.selectedPersona$.pipe(
            map(persona => !!persona && !this.isEveryonePersona(persona) ? toPersonaUI(persona) : null)
        );
    }

    private isEveryonePersona = (persona: Persona) => persona.name.toLowerCase() === 'everyone';

    isTypePersona(type: PersonaUITypes) {
        return type === PersonaUITypes.PERSONA;
    }

    constructor(
        private personaPicker: PersonaPickerService
    ) {}

    ngOnInit() {
        this.selectedPersonaUI$ = this.getSelectedPersonaUI$();
        this.hasToSelectPersona$ = this.personaPicker.hasToSelectPersona$;
        this.getConfirm$(this.personaPicker.toSelectPersona$).subscribe();
    }

}


